<template>
    <div class="container the-menu" :class="{'menu-open': menuOpen}">
        <b-navbar-nav>
            <div class="align-items-center card flex-row mb-2 p-2" v-if="isOffline">
                <icon-signal-none size="sm" class="mr-2"></icon-signal-none> <span>Offline</span>
            </div>
            <b-nav-item :to="{ name: 'dashboard'}" @click="toggleMenu()">Home</b-nav-item>
            <template v-if="isTechnician">
                <b-nav-item :to="{ name: 'jobList'}" @click="toggleMenu()">Today's repair jobs</b-nav-item>
<!--                <b-nav-item :to="{ name: 'dailyChecklist'}" @click="toggleMenu()">Daily checklist</b-nav-item>-->
                <b-nav-item :to="{ name: 'technicianInboundShipments'}" @click="toggleMenu()">Inbound shipments</b-nav-item>
                <b-nav-item :to="{ name: 'technicianOutboundShipments'}" @click="toggleMenu()">Outbound shipments</b-nav-item>
            </template>
            <template v-if="isInHouseTechnician">
                <b-nav-item :to="{ name: 'inHouseRepairs'}" @click="toggleMenu()">Pending In-House Repairs</b-nav-item>
            </template>
            <template v-if="isSuperAdmin">
                <b-nav-item :to="{ name: 'repairKitPicking'}" @click="toggleMenu()">Repair kit picking</b-nav-item>
                <b-nav-item :to="{ name: 'repairKitPacking'}" @click="toggleMenu()">Repair kit packing</b-nav-item>
                <b-nav-item :to="{ name: 'bulkRepairImeiSearch'}" @click="toggleMenu()">Asset IMEI search</b-nav-item>
                <b-nav-item :to="{ name: 'outboundShipments'}" @click="toggleMenu()">Outbound shipments</b-nav-item>
                <b-nav-item :to="{ name: 'inHouseRepairs'}" @click="toggleMenu()">Pending In-House Repairs</b-nav-item>
            </template>
            <b-nav-item :to="{ name: 'logout'}" @click="toggleMenu()" class="mt-5"><i class="fa fa-power-off mr-2"></i> Log out</b-nav-item>
            <span class="version-number">Version: {{version}}</span>
        </b-navbar-nav>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    const { version } = require('../../../package.json')

    export default {
        data() {
            return {
                version: version
            }
        },

        computed: {
            ...mapGetters([
                "isInHouseTechnician",
                "isSuperAdmin",
                "isTechnician",
                "menuOpen"
            ]),
        },

        methods: {
            ...mapActions([
                "toggleMenu",
            ]),
        }
    }
</script>

<style scoped>

</style>